import { PaletteMode } from "@mui/material";
import { PaletteColor, PaletteColorOptions } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface Palette {
    software?: PaletteColor;
    testing?: PaletteColor;
  }
  interface PaletteOptions {
    software?: PaletteColorOptions;
    testing?: PaletteColorOptions;
  }
}

const getDesignTokens = (mode: PaletteMode) => ({
  palette: {
    mode,
    ...{
      primary: {
        main: "#191621",
        text: "#fff",
      },
      secondary: {
        main: "#81BC00",
        dark: "#81BC002B",
      },
      testing: {
        main: "#81BC00",
        dark: "#81BC0014",
      },
      software: {
        main: "#705B95",
        dark: "#2A2537",
      },
    },
  },
  typography: {
    fontFamily: ['"Montserrat"', "Open Sans"].join(","),
    allVariants: {
      color: "#ffffff",
    },
  },
  overrides: {
    MuiButton: {
      label: {
        color: "#f1f1f1",
      },
    },
    MuiTooltip: {
      tooltip: {
        fontSize: "2em",
        color: "yellow",
        backgroundColor: "red",
      },
    },
  },
});

export default getDesignTokens;
